import { render, staticRenderFns } from "./tab-share.vue?vue&type=template&id=07069de8&"
import script from "./tab-share.vue?vue&type=script&lang=js&"
export * from "./tab-share.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports